import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentTab: localStorage.getItem('TAB') || false,
};

const tabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    setTab: (state, action) => {
      state.currentTab = action.payload;
      if (action.payload) {
        localStorage.setItem('TAB', action.payload);
      } else {
        localStorage.removeItem('TAB');
      }
    },
    clearTab: (state) => {
      state.currentTab = false;
      localStorage.removeItem('TAB');
    },
  },
});

export const { setTab, clearTab } = tabSlice.actions;
export const selectCurrentTab = (state) => state.tab.currentTab;
export default tabSlice;
